import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import {AccessRights} from "lib/constants/accessRights";
import MainPageComponent from "./otp-report.page";
import LoadingComponent from "components/loading";
import { OtpReportProvider } from "modules/otp-report/context/otpReport.context";
import messageApi from "app/api/message";
import { addAlert } from "modules/notification";
import { getApiLang } from "app/feature/constants";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

export default function MainPageContainer() {
  const dispatch = useDispatch();
  const history = useHistory();
  const hasOtpReportViewAccessRight = useSelector(state => canAccess(state, AccessRights.OtpReporting.MODULE));
  const lang = useSelector(state => state.constant.languages);

  const [isLoading, setIsLoading] = useState(true);
  const [totalSpent, setTotalSpent] = useState(0);

  useEffect(() => {
    if (!hasOtpReportViewAccessRight) {
      history.push("/admin/dashboard");
    }
  }, [history, hasOtpReportViewAccessRight]);

  useEffect(() => {
    setIsLoading(true);
    messageApi
      .totalSpentReport()
      .then((response) => {
        setTotalSpent(response.data.data.total_spent);
      })
      .catch((error) => {
        dispatch(
          addAlert({
            severity: "error",
            message: getApiLang(lang, error.code),
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!hasOtpReportViewAccessRight) return <LoadingComponent />;

  return (
    <OtpReportProvider>
      <MainPageComponent
        lang={lang}
        totalSpent={totalSpent}
        isLoading={isLoading}
      />
    </OtpReportProvider>
  );
}
